import React from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../redux/actions';

// เมนูคลิกขวาเลือก "อนุมัติ/ไม่อนุมัติ" งบประมาณตรงๆ ในตาราง — ต่างจาก field อื่นที่เปิด
// CellEditModal (ต้องกดปุ่ม "บันทึก" อีกที) budget_approve เป็น boolean ล้วนๆ ไม่มีค่าให้กรอก
// เพิ่ม เลยกดเลือกแล้วบันทึก+ปิดเมนูทันที ไม่ต้องเปิด modal เต็มรูปแบบ
//
// ใช้ anchorReference="anchorPosition" (จดพิกัดหน้าจอตายตัวตอนคลิกขวา) แทนผูกกับ DOM node ของ
// แถวโดยตรง กันเมนูเด้งไปมุมจอถ้าแถวหลุดจาก filter/sort ระหว่างเปิดเมนูอยู่ — ปัญหาเดียวกับที่
// เจอมาก่อนใน P5 (ดู CLAUDE.md gotcha ของ Dim3Popover)
export default function BudgetApproveMenu({ target, onClose, onSaved }) {
  const dispatch = useDispatch();

  const handlePick = async (value) => {
    const row = target?.row;
    onClose();
    if (!row || row.budget_approve === value) return;
    await dispatch(actions.updateOpportunity({ id: row.id, budgetApprove: value }));
    onSaved?.();
  };

  return (
    <Menu
      open={!!target}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={target ? { top: target.mouseY, left: target.mouseX } : undefined}
    >
      <MenuItem onClick={() => handlePick(true)}>
        <ListItemIcon><CheckCircleOutlineIcon fontSize="small" color="success" /></ListItemIcon>
        <ListItemText>อนุมัติ</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => handlePick(false)}>
        <ListItemIcon><HighlightOffIcon fontSize="small" color="disabled" /></ListItemIcon>
        <ListItemText>ไม่อนุมัติ</ListItemText>
      </MenuItem>
    </Menu>
  );
}
